import * as React from 'react'
import parse, {
  attributesToProps,
  Element,
  HTMLReactParserOptions,
  domToReact
} from 'html-react-parser'
import { PhotoConsumer, PhotoProvider } from 'react-photo-view'
import ReactPlayer from 'react-player'
import screenfull from 'screenfull'
import styles from './index.module.scss'
import { purchaseLinkParams, reportFn } from '@feedback/utils/util'

const Video: React.FC<{ src: string }> = ({ src }) => {
  const player = React.useRef(null)
  const [playing, setPlaying] = React.useState(false)
  const [isReady, setReady] = React.useState(false)
  const [isError, setError] = React.useState(false)

  const handleClickFullscreen = () => {
    if (screenfull.isEnabled) {
      screenfull.request((player.current as any)?.wrapper)
    }
  }

  return (
    <section
      className={`${styles['player-wrapper']} ${
        !isReady ? styles['is-init'] : ''
      }`}
    >
      <ReactPlayer
        ref={player}
        className='react-player'
        url={src}
        width='100%'
        height={190}
        controls={true}
        playing={playing}
        playIcon={<></>}
        onReady={() => {
          setReady(true)
        }}
        onError={() => {
          setError(true)
        }}
      />
      {isError && <div className='error-message'>load fail</div>}
    </section>
  )
}

const options: HTMLReactParserOptions = {
  replace: (domNode) => {
    const typedDomNode = domNode as Element

    if (typedDomNode.attribs && typedDomNode.name === 'img') {
      const imgProps = attributesToProps(typedDomNode.attribs)
      return (
        <PhotoConsumer src={imgProps.src}>
          <img {...imgProps} style={{ maxWidth: '100%', cursor: 'pointer' }} />
        </PhotoConsumer>
      )
    }

    if (typedDomNode.attribs && typedDomNode.name === 'video') {
      return <Video src={attributesToProps(typedDomNode.attribs)?.src} />
    }

    if (typedDomNode.attribs && typedDomNode.name === 'a') {
      const aProps = attributesToProps(typedDomNode.attribs)
      const newURL = purchaseLinkParams(aProps.href, {
        entry_type: '2'
      })
      return (
        <a
          {...aProps}
          href={newURL}
          onClick={() => {
            const { faq_id } = Object.fromEntries(
              new URLSearchParams(location.href.split('?')[1])
            )
            reportFn({ parm1: 3, parm2: 3, parm6: faq_id || '' })
          }}
        >
          {domToReact(typedDomNode.children)}
        </a>
      )
    }

    return false
  }
}

const Index: React.FC<{ html: string }> = ({ html }) => {
  return (
    <>
      <PhotoProvider>{parse(html, options)}</PhotoProvider>
    </>
  )
}

export default Index
